import * as React from 'react';
import AddIcon from '@mui/icons-material/Add';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

type SEPlayAddImagesListButtonProps = {
    handleAddImagesView: () => void;
    label: string;
};

const SEPlayEditDialogAddButton = (props: SEPlayAddImagesListButtonProps) => {
    const { handleAddImagesView, label } = props;

    return (
        <Box
            sx={{
                position: 'relative',
                height: '143px',
                borderRadius: '4px',
                display: 'flex',
                justifyContent: 'flex-start',
                flexDirection: 'column'
            }}
        >
            <Button
                aria-label="add-images-to-slideshow"
                sx={{
                    width: '160px',
                    height: '109px',
                    borderRadius: '2px',
                    backgroundColor: 'rgba(0, 0, 0, 0.12)',
                    color: 'white',
                    padding: 0
                }}
                onClick={handleAddImagesView}
            >
                <AddIcon fontSize={'medium'} />
            </Button>
            <Typography
                justifyItems="center"
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignContent: 'center',
                    marginTop: '12px'
                }}
            >
                {label}
            </Typography>
        </Box>
    );
};
export default SEPlayEditDialogAddButton;
